import { AdminLevelFormI, ValidationSet } from '../../../../types/interface';

export const AdminLevelValidationSet: ValidationSet<AdminLevelFormI> = {
  level_name: [],
  level_name_german: [],
  level_order: []
};
